export default __webpack_public_path__ + "static/media/team2.27b0d46a.png";